import React from 'react'

const CustomTruncatedText = ({ text = "", maxLength = 60, className = "" }) => {
    const displayText = text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  
    return (
      <div
        className={`truncate cursor-pointer ${className}`}
        title={text}
      >
        {displayText.replace(/\b\w/g, (char) => char.toUpperCase())}
      </div>
    );
  };

export default CustomTruncatedText
